export const PROJECT_AUTOFILL_DOCUMENT_ACCEPT =
  'application/pdf,image/jpeg,image/png,image/webp,.csv,text/csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export function getComposerFileAccept(allowVideo: boolean, allowDocuments: boolean): string {
  if (allowVideo) {
    return 'image/jpeg,image/png,image/webp,video/mp4,video/webm'
  }
  if (allowDocuments) {
    return PROJECT_AUTOFILL_DOCUMENT_ACCEPT
  }
  return 'image/jpeg,image/png,image/webp'
}

export function composerUsesMediaOnlyIcon(allowVideo: boolean, allowDocuments: boolean): boolean {
  return allowVideo || !allowDocuments
}
